export var faqs = [
  {
    title: 'Curabitur sodales ligula in libero?',
    value: 'Sed lectus. Integer euismod lacus luctus magna. Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.',
    filterTags: [
      'topic-1',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Nulla metus metus, ullamcorper vel, tincidunt sed?',
    value: 'Morbi lacinia molestie dui. Praesent blandit dolor. Sed non quam. In vel mi sit amet augue congue elementum. Morbi in ipsum sit amet pede facilisis laoreet. Donec lacus nunc, viverra nec, blandit vel, egestas et, augue. Vestibulum tincidunt malesuada tellus.',
    topic: 'topic-2',
    filterTags: [
      'topic-1',
      'audience-1'
    ]
    // category: 'Tab-2'
  },
  {
    title: 'Etiam ultrices. Suspendisse in justo eu magna luctus suscipit?',
    value: 'Nunc feugiat mi a tellus consequat imperdiet:<br><ul> \n' +
    '    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.</li>\n' +
    '    <li>Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta.</li>\n' +
    '    <li>Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. </li>\n' +
    '    <li>Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam. In scelerisque sem at dolor. Maecenas mattis. </li></ul> ',
    filterTags: [
      'topic-3',
      'audience-1'
    ]
    // category: 'Tab-2'
  },
  {
    title: 'Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh?',
    value: '    <ul> <li> Volutpat <a href="https://maxtest.net" target="_blank">www.maxtest.net</a> quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. </li>\n' +
    '    <li> Sed lectus. Integer euismod lacus luctus magna. Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam. </li>\n' +
    '    <li> Sed lectus. Integer euismod lacus luctus magna. Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam. </li></ul> ',
    filterTags: [
      'topic-1',
      'audience-1'
    ]
    // category: 'Tab-2'
  },
  {
    title: 'Proin sodales libero eget ante. Nulla quam?',
    value: 'Nulla facilisi. Integer lacinia sollicitudin massa. Cras metus. Sed aliquet risus a tortor. Integer id quam. Morbi mi. Quisque nisl felis, venenatis tristique, dignissim in<br><br>\n' +
    'Egestas maecenas pharetra convallis posuere morbi leo. Viverra accumsan in nisl nisi scelerisque eu ultrices vitae auctor.<br><br>\n' +
    'Viverra accumsan:<br>\n' +
    'Nulla facilisi. Integer lacinia sollicitudin massa.',
    filterTags: [
      'topic-3',
      'audience-1'
    ]
    // category: 'Tab-2'
  },
  {
    title: 'Nisl condimentum id venenatis a condimentum?',
    value: 'Amet mauris commodo quis imperdiet massa tincidunt nunc:<br><ul>\n' +
    '    <li> Congue nisi vitae suscipit tellus mauris a diam maecenas</li>\n' +
    '    <li> Ut morbi tincidunt augue interdum velit euismod in.</li>\n',
    filterTags: [
      'topic-2',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Ac felis donec et odio pellentesque diam. Risus sed vulputate?',
    value: 'Nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper. Vitae semper quis lectus nulla at volutpat. Metus dictum at tempor commodo ullamcorper a lacus.<br><br>\n' +
    'Nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper. Vitae semper quis lectus nulla at volutpat. Metus dictum at tempor commodo ullamcorper a lacus. ',
    filterTags: [
      'topic-2',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Vel pharetra vel turpis nunc. Lacus laoreet non curabitur gravida arcu?',
    value: 'Vel orci porta non pulvinar neque laoreet suspendisse interdum. Integer quis auctor elit sed vulputate. Proin sagittis nisl rhoncus mattis rhoncus urna neque. ',
    filterTags: [
      'topic-2',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Dictumst quisque sagittis purus sit. Faucibus?',
    value: 'Suscipit tellus mauris a diam maecenas sed enim ut sem. Massa placerat duis ultricies lacus sed turpis tincidunt. Proin fermentum leo vel orci porta non pulvinar neque laoreet. Dolor sed viverra ipsum nunc. Blandit aliquam etiam erat velit scelerisque in dictum. Fermentum iaculis eu non diam phasellus vestibulum. Fames ac turpis egestas sed tempus urna. Ut faucibus pulvinar elementum integer. Nascetur ridiculus mus mauris vitae ultricies leo.',
    filterTags: [
      'topic-1',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Ac placerat vestibulum lectus mauris ultrices. Dignissim cras tincidunt lobortis feugiat vivamus at?',
    value: 'Magna eget est lorem ipsum dolor sit amet. Ac turpis egestas maecenas pharetra convallis posuere morbi leo. Fermentum posuere urna nec tincidunt praesent semper feugiat. Proin fermentum leo vel orci porta non pulvinar neque laoreet.' +
    '<br><br>Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum. Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper. Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in. Sit amet tellus cras adipiscing enim eu turpis egestas pretium. Tellus molestie nunc non blandit massa enim nec dui nunc. Neque vitae tempus quam pellentesque nec nam aliquam sem.',
    filterTags: [
      'topic-1',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Magna ac placerat vestibulum lectus mauris ultrices eros. Orci phasellus egestas tellus rutrum tellus pellentesque eu. Pretium aenean pharetra magna ac placerat?',
    value: 'Faucibus ornare suspendisse sed nisi lacus sed viverra. Eget gravida cum sociis natoque penatibus et. Facilisis magna etiam tempor orci eu lobortis elementum:' +
    '<ul><li>Sed nisi lacus sed viverra tellus in. Quis eleifend quam adipiscing vitae proin sagittis nisl rhoncus mattis.' +
   '<br>Tincidunt ornare massa eget egestas purus viverra. Eget felis eget nunc lobortis. Dictumst vestibulum rhoncus est pellentesque elit ullamcorper.</li>' +
    '<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</li>' +
    '</ul>',
    filterTags: [
      'topic-3',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Ultricies leo integer malesuada nunc vel. Etiam non quam lacus suspendisse faucibus interdum?',
    value: 'Adipiscing enim eu turpis egestas. Tincidunt ornare massa eget egestas purus viverra accumsan. Ultrices vitae auctor eu augue ut lectus. Interdum posuere lorem ipsum dolor sit amet consectetur. Sed enim ut sem viverra aliquet eget sit amet. Neque ornare aenean euismod elementum nisi quis eleifend quam. In est ante in nibh mauris cursus mattis molestie. Fermentum odio eu feugiat pretium nibh ipsum. Tortor id aliquet lectus proin nibh nisl condimentum id. Vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae elementum. In est ante in nibh mauris cursus. Diam vel quam elementum pulvinar. Senectus et netus et malesuada fames. Ac turpis egestas sed tempus.',
    filterTags: [
      'topic-3',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Egestas maecenas pharetra convallis posuere morbi leo. Viverra accumsan in nisl nisi scelerisque eu ultrices vitae auctor?',
    value: 'Nisl condimentum id venenatis a condimentum: \n' +
    '<ul>\n' +
    '<li>Amet mauris commodo quis imperdiet massa tincidunt nunc?</li>\n' +
    '<li>Congue nisi vitae suscipit tellus mauris a diam maecenas?</li>\n' +
    '<li>Ut morbi tincidunt augue interdum velit euismod in?</li>\n' +
    '</ul>\n' +
    'Ac felis donec et odio pellentesque diam. Risus sed vulputate odio ut enim blandit volutpat maecenas volutpat. Nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper. Vitae semper quis lectus nulla at volutpat.',
    filterTags: [
      'topic-2',
      'audience-1'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Vel pharetra vel turpis nunc. Lacus laoreet non curabitur gravida arcu. Vel orci porta non pulvinar neque laoreet suspendisse interdum?',
    value: 'Integer quis auctor elit sed vulputate. Proin sagittis nisl rhoncus mattis rhoncus urna neque. \n' +
    '<br><br>' +
    'Dictumst quisque sagittis purus sit. Faucibus pulvinar elementum integer enim neque. Suscipit tellus mauris a diam maecenas sed enim ut sem. Massa placerat duis ultricies lacus sed turpis tincidunt.\n' +
    '<br><br>' +
    'Proin fermentum leo vel orci porta non pulvinar neque laoreet. Dolor sed viverra ipsum nunc. Blandit aliquam etiam erat velit scelerisque in dictum. Fermentum iaculis eu non diam phasellus vestibulum.',
    filterTags: [
      'topic-3',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Ac placerat vestibulum lectus mauris ultrices. Dignissim cras tincidunt lobortis feugiat vivamus at?',
    value: 'Magna eget est lorem ipsum dolor sit amet. Ac turpis egestas maecenas pharetra convallis posuere morbi leo. Fermentum posuere urna nec tincidunt praesent semper feugiat:\n' +
    '<br><ul>' +
    '    <li>Proin fermentum leo vel orci porta non pulvinar neque laoreet. </li>\n' +
    '    <li>Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. </li>\n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '</ul>',
    filterTags: [
      'topic-4',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Sit amet tellus cras adipiscing enim eu turpis egestas pretium? ',
    value: 'Tellus molestie nunc non blandit massa enim nec dui nunc. Neque vitae tempus quam pellentesque nec nam aliquam sem. Tellus molestie nunc non blandit massa enim nec dui nunc. Neque vitae tempus quam pellentesque nec nam aliquam sem.',
    filterTags: [
      'topic-4',
      'topic-5',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Get gravida cum sociis natoque penatibus et. Facilisis magna etiam tempor orci eu lobortis elementum?',
    value: 'Magna ac placerat vestibulum lectus mauris ultrices eros. Orci phasellus egestas tellus rutrum tellus pellentesque eu. Pretium aenean pharetra magna ac placerat: <a href="https://maxtest.net" target="_blank">www.maxtest.net</a>. Aucibus ornare suspendisse sed nisi lacus sed viverra: <a href="mailto:mail@maxtest.net">mail@maxtest.net</a>. ',
    filterTags: [
      'topic-1',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Aenean laoreet. Vestibulum nisi lectus, commodo ac, facilisis ac, ultricies eu, pede. Ut orci risus, accumsan porttitor, cursus quis, aliquet eget, justo? ',
    value: 'Morbi lacinia molestie dui. Praesent blandit dolor. Sed non quam. In vel mi sit amet augue congue elementum. Morbi in ipsum sit amet pede facilisis laoreet. Donec lacus nunc, viverra nec, blandit vel, egestas et, augue. Vestibulum tincidunt malesuada tellus. Ut ultrices ultrices enim. Curabitur sit amet mauris. Morbi in dui quis est pulvinar ullamcorper.',
    filterTags: [
      'topic-3',
      'topic-5',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit?',
    value: 'Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti.',
    filterTags: [
      'topic-4',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Curae; Morbi lacinia molestie dui. Praesent blandit dolor. Sed non quam. In vel mi sit amet augue congue elementum. Morbi? ',
    value: 'Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti.',
    filterTags: [
      'topic-5',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Quis eleifend quam adipiscing vitae proin sagittis nisl rhoncus mattis?',
    value: 'Tincidunt ornare massa eget egestas purus viverra. Eget felis eget nunc lobortis. Dictumst vestibulum rhoncus est pellentesque elit ullamcorper. Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. Adipiscing tristique risus nec feugiat in fermentum. \n' +
    '<br><br>\n' +
    'Quis ipsum suspendisse ultrices gravida dictum. Quis ipsum suspendisse ultrices gravida dictum.',
    filterTags: [
      'topic-3',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Tortor id aliquet lectus proin nibh nisl condimentum id?',
    value: 'Etiam non quam lacus suspendisse faucibus interdum. Adipiscing enim eu turpis egestas. Tincidunt ornare massa eget egestas purus viverra accumsan. Ultrices vitae auctor eu augue ut lectus. Interdum posuere lorem ipsum dolor sit amet consectetur. Sed enim ut sem viverra aliquet eget sit amet. Neque ornare aenean euismod elementum nisi quis eleifend quam. In est ante in nibh mauris cursus mattis molestie. Fermentum odio eu feugiat pretium nibh ipsum.',
    filterTags: [
      'topic-5',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae elementum?',
    value: 'Egestas maecenas pharetra convallis posuere morbi leo. Viverra accumsan in nisl nisi scelerisque eu ultrices vitae auctor. Nisl condimentum id venenatis a condimentum. Amet mauris commodo quis imperdiet massa tincidunt nunc. Egestas maecenas pharetra convallis posuere morbi leo. Viverra accumsan in nisl nisi scelerisque eu ultrices vitae auctor. Nisl condimentum id venenatis a condimentum. Amet mauris commodo quis imperdiet massa tincidunt nunc.',
    filterTags: [
      'topic-3',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Congue nisi vitae suscipit tellus mauris a diam maecenas?',
    value: 'Ut morbi tincidunt augue interdum velit euismod in. Ac felis donec et odio pellentesque diam. Risus sed vulputate odio ut enim blandit volutpat maecenas volutpat. Nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper.\n' +
    '<br><br>\n' +
    'Vel pharetra vel turpis nunc. Lacus laoreet non curabitur gravida arcu. Vel orci porta non pulvinar neque laoreet suspendisse interdum. Integer quis auctor elit sed vulputate. Proin sagittis nisl rhoncus mattis rhoncus urna neque.',
    filterTags: [
      'topic-3',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Dictumst quisque sagittis purus sit. Faucibus pulvinar elementum integer enim neque?',
    value: 'Suscipit tellus mauris a diam maecenas sed enim ut sem. Massa placerat duis ultricies lacus sed turpis tincidunt. Proin fermentum leo vel orci porta non pulvinar neque laoreet. Dolor sed viverra ipsum nunc. Blandit aliquam etiam erat velit scelerisque in dictum. Fermentum iaculis eu non diam phasellus vestibulum. ',
    filterTags: [
      'topic-2',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Ac placerat vestibulum lectus mauris ultrices. Dignissim cras tincidunt lobortis feugiat vivamus at. Magna eget est lorem ipsum dolor sit amet?',
    value: 'Ac turpis egestas maecenas pharetra convallis posuere morbi leo:\n' +
    '<br>\n' +
    '<ul> \n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '    <li>Proin fermentum leo vel orci porta non pulvinar neque laoreet. </li>\n' +
    '    <li>Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. </li>\n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '</ul>\n' +
    '<br>\n' +
    'Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum <a href="mailto:mail@maxtest">mail@maxtest.net</a>, duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.',
    filterTags: [
      'topic-6',
      'audience-2'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper?',
    value: 'Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet:\n' +
    '<br><br><ul>\n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '    <li>Proin fermentum leo vel orci porta non pulvinar neque laoreet. </li>\n' +
    '    <li>Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. </li>\n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '    <li>Tellus molestie nunc non blandit massa enim nec dui nunc.</li></ul>',
    filterTags: [
      'topic-6',
      'audience-3'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Magna ac placerat vestibulum lectus mauris ultrices eros. Orci phasellus egestas tellus rutrum tellus pellentesque eu?',
    value: 'Pretium aenean pharetra magna ac placerat. Faucibus ornare suspendisse sed nisi lacus sed viverra:<br><br><ul>\n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '    <li>Proin fermentum leo vel orci porta non pulvinar neque laoreet. </li>\n' +
    '    <li>Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. </li>\n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '    <li>Tellus molestie nunc non blandit massa enim nec dui nunc.</li></ul>',
    filterTags: [
      'topic-5',
      'audience-3'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Neque ornare aenean euismod elementum nisi quis eleifend quam. In est ante in nibh mauris cursus mattis molestie?',
    value: 'Magna ac placerat vestibulum lectus mauris ultrices eros. Orci phasellus egestas tellus rutrum tellus pellentesque eu. Pretium aenean pharetra magna ac placerat. Faucibus ornare suspendisse sed nisi lacus sed viverra. Eget gravida cum sociis natoque penatibus et. Facilisis magna etiam tempor orci eu lobortis elementum. Sed nisi lacus sed viverra tellus in. Quis eleifend quam adipiscing vitae proin sagittis nisl rhoncus mattis. Tincidunt ornare massa eget egestas purus viverra. Eget felis eget nunc lobortis. Dictumst vestibulum rhoncus est pellentesque elit ullamcorper.',
    filterTags: [
      'topic-6',
      'audience-3'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Adipiscing enim eu turpis egestas. Tincidunt ornare massa eget egestas purus viverra accumsan?',
    value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ultricies leo integer malesuada nunc vel. Etiam non quam lacus suspendisse faucibus interdum. Adipiscing enim eu turpis egestas. Tincidunt ornare massa eget egestas purus viverra accumsan. Ultrices vitae auctor eu augue ut lectus. Interdum posuere lorem ipsum dolor sit amet consectetur.',
    filterTags: [
      'topic-6',
      'audience-3'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Sed enim ut sem viverra aliquet eget sit amet. Neque ornare aenean euismod elementum nisi quis eleifend quam?',
    value: 'Tortor id aliquet lectus proin nibh nisl condimentum id. Vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae elementum. In est ante in nibh mauris cursus. Diam vel quam elementum pulvinar. Senectus et netus et malesuada fames. Ac turpis egestas sed tempus. Tortor id aliquet lectus proin nibh nisl condimentum id. Vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae elementum. In est ante in nibh mauris cursus. Diam vel quam elementum pulvinar. Senectus et netus et malesuada fames. Ac turpis egestas sed tempus.',
    filterTags: [
      'topic-4',
      'audience-3'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Neque ornare aenean euismod elementum nisi quis eleifend quam. In est ante in nibh mauris cursus mattis molestie?',
    value: 'Ac felis donec et odio pellentesque diam. Risus sed vulputate odio ut enim blandit volutpat maecenas volutpat. Nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper.',
    filterTags: [
      'audience-3'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Vel pharetra vel turpis nunc. Lacus laoreet non curabitur gravida arcu. Vel orci porta non pulvinar neque laoreet suspendisse interdum. Integer quis auctor elit sed vulputate. Proin sagittis nisl rhoncus mattis rhoncus urna neque?',
    value: 'Massa placerat duis ultricies lacus sed turpis tincidunt. Proin fermentum leo vel orci porta non pulvinar neque laoreet. Dolor sed viverra ipsum nunc. Blandit aliquam etiam erat velit scelerisque in dictum <a href="https://www.maxtest.net" target="_blank">www.maxtest.net</a> Fermentum iaculis eu non diam phasellus vestibulum.\n' +
    '<br><br>\n' +
    'Fermentum posuere urna nec tincidunt praesent semper feugiat. Proin fermentum leo vel orci porta non pulvinar neque laoreet. Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. Adipiscing tristique risus nec feugiat in fermentum.',
    filterTags: [
      'topic-3',
      'audience-3'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet?',
    value: 'Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam. In scelerisque sem at dolor. Maecenas mattis. Sed convallis tristique sem. Proin ut ligula vel nunc egestas porttitor. Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa. Fusce ac turpis quis ligula lacinia aliquet. Mauris ipsum:<br><br><ul>\n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '    <li>Proin fermentum leo vel orci porta non pulvinar neque laoreet. </li>\n' +
    '    <li>Duis at consectetur lorem donec massa sapien faucibus et. Viverra vitae congue eu consequat ac felis donec. </li>\n' +
    '    <li>Adipiscing tristique risus nec feugiat in fermentum. Quis ipsum suspendisse ultrices gravida dictum.</li>\n' +
    '    <li>Rhoncus mattis rhoncus urna neque viverra. Volutpat ac tincidunt vitae semper.</li>\n' +
    '    <li>Vel pharetra vel turpis nunc eget lorem. Metus vulputate eu scelerisque felis imperdiet. Congue quisque egestas diam in.</li>\n' +
    '    <li>Tellus molestie nunc non blandit massa enim nec dui nunc.</li></ul>',
    filterTags: [
      'topic-3',
      'audience-4'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Maecenas mattis. Sed convallis tristique sem. Proin ut ligula vel nunc egestas porttitor. ?',
    value: 'Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. ',
    filterTags: [
      'topic-3',
      'audience-4'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Morbi in ipsum sit amet pede facilisis laoreet?',
    value: 'Sed lectus. Integer euismod lacus luctus magna. Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Morbi lacinia molestie dui. ',
    filterTags: [
      'topic-3',
      'topic-5',
      'audience-4'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit?',
    value: 'Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.',
    filterTags: [
      'audience-4'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam. In scelerisque sem at dolor. Maecenas mattis?',
    value: 'Curae; Morbi lacinia molestie dui. Praesent blandit dolor. Sed non quam. In vel mi sit amet augue congue elementum. Morbi in ipsum',
    filterTags: [
      'topic-3',
      'topic-7',
      'audience-4'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Morbi lacinia molestie dui. Praesent blandit dolor?',
    value: 'Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. ',
    filterTags: [
      'topic-7',
      'audience-5'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Convallis tristique sem. Proin ut ligula vel nunc?',
    value: 'Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh. Aenean quam. In scelerisque sem at dolor. Maecenas mattis. Sed convallis tristique sem. Proin ut ligula vel nunc egestas porttitor. Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa. Fusce ac turpis quis ligula lacinia aliquet. Mauris ipsum.',
    filterTags: [
      'topic-7',
      'audience-5'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante?',
    value: 'Aenean quam. In scelerisque sem at dolor. Maecenas mattis. Sed convallis tristique sem. Proin ut ligula vel nunc egestas porttitor. Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa. Fusce ac turpis quis ligula lacinia aliquet. Mauris ipsum. Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. ',
    filterTags: [
      'audience-5'
    ]
    // category: 'Tab-1'
  },
  {
    title: 'Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices?',
    value: 'Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. Sed lectus. Integer euismod lacus luctus magna. Quisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam.',
    filterTags: [
      'topic-4',
      'audience-5'
    ]
    // category: 'Tab-1'
  }
  // {
  //   title: '',
  //   value: '',
  //   filterTags: [
  //     'topic-2',
  //     'audience-2'
  //   ]
  //   // category: 'Tab-1'
  // }
]



// WEBPACK FOOTER //
// ./src/global/faqs.js